import { render } from "./TriagedReport.vue?vue&type=template&id=08a1a13c&ts=true"
import script from "./TriagedReport.vue?vue&type=script&lang=ts"
export * from "./TriagedReport.vue?vue&type=script&lang=ts"

import "./TriagedReport.vue?vue&type=style&index=0&id=08a1a13c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__